/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
    'SolitaireShared/CardLogic/CardColor',{
        "None": 0,
        "Red": 1,
        "Black": 2
    }
);

